import { Directive, HostListener, Input, HostBinding, ElementRef, Renderer2 } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from 'rxjs';

@Directive({
    selector: 'button[appClickWait]'
})
export class ClickWaitDirective {
    private subscription?: Subscription;

    constructor(
        private spinnerService: NgxSpinnerService,
        private el: ElementRef,
        private renderer: Renderer2
    ) {
    }

    @HostBinding('disabled')
    public waiting: boolean;

    @Input()
    public clickWaitDisabled: boolean = false;

    @Input()
    public spinnerName: string;

    @Input()
    appClickWait: () => Promise<any> = async () => void 0;

    @HostListener('click')
    clickEvent(): void {
        this.waiting = true;
        this.spinnerService.hide();

        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
        //in cse of modal the setTimeout is a fix to force the spinner to appear
        if (this.spinnerName) {
            setTimeout(() => {

                this.spinnerService.show(this.spinnerName);
            }, 0);
        } else {
            setTimeout(() => {
                this.spinnerService.show();
            }, 0);
        }

        this.appClickWait()
            .then(() => {
                setTimeout(() => {
                    this.finalizeAppClickWait();
                }, 350);
            }).catch((err) => {
                console.error(err);
                setTimeout(() => {
                    this.finalizeAppClickWait();
                }, 350);
            });

    }

    private finalizeAppClickWait() {
        if (!this.clickWaitDisabled) {
            this.waiting = false;
        }
        this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
        if (this.spinnerName) {
            this.spinnerService.hide(this.spinnerName);
        } else {
            this.spinnerService.hide();
        }
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        //in case of modal we need to hide here
        if (this.spinnerName) {
            this.spinnerService.hide(this.spinnerName);
        } else {
            this.spinnerService.hide();
        }
    }
}
